import styled from 'styled-components';
import { orange } from 'constants/colors';
import { RalewayFont } from 'constants/fonts';

export const FinishSpeedDatingWrapper = styled.div`
  text-align: center;

  .users {
    white-space: nowrap;
    max-width: 23rem;
    margin: 0 auto 2rem;
    white-space: nowrap;

    > div {
      width: 50%;
      display: inline-block;

      &:first-child {
        text-align: left;

        .avatar_bubble {
          border: 0.3rem solid ${orange};
        }
      }
      &:last-child {
        text-align: right;
        .avatar_bubble {
          border: 0.1rem solid #000;
        }
      }
    }

    .speed_dating_icon {
      margin: -2rem -4.5rem 0;
      position: relative;
      z-index: 10;
    }
  }

  .central_grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 2rem;
    width: 35rem;
    margin: 2rem auto;
    max-width: 100%;
    align-items: center;

    .speed_card {
      border-radius: 1.5rem;
      box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
      max-width: 100%;
      width: 17rem;
      .header {
        background-color: #2680EB;
        color: #fff;
        border-radius: 1.5rem 1.5rem 0 0;
        padding: 1rem;


        .icon {
          background: white;
          border-radius: 100%;
          border-radius: 100%;
          width: 3rem;
          height: 3rem;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 1rem;
          display: inline-block;
          vertical-align: top;
          img {
              height: 3rem;
              width: 3rem;
          }
        }
        .data {
            width: calc(100% - 5rem);
            font-family: ${RalewayFont.semiBoldFamily};
            color: white;
            font-size: 1.8rem;
            display: inline-block;
            vertical-align: top;
            margin-left: 1rem;
            text-align: left;
        }
      }

      .body {
        padding: 1rem;
        text-align: left;
        .user_name {
          display: inline-block;
          vertical-align: middle;
          font-size: 1.2rem;
          margin-left: 1rem;
          width: calc(100% - 4.5rem);
          line-height: 1.4rem;
        }
      }
    }
  }

  .bottom_grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 2rem;
    width: 45rem;
    margin: 2rem auto;
    max-width: 100%;
    align-items: center;

    button {
      width: 100%;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/NotificationsTypes/FinishSpeedDating/components/styles.js